import { useState } from "react";
import MESSAGES from "../../common/data/constants/messages";
import { IWorkOrder } from "../../common/data/dtos/work-order";
import workOrderReportService from "../../services/work-order-report-service";
import Button from '../bootstrap/Button';
import Spinner from "../bootstrap/Spinner";
import { showSuccess, showWarning } from "./Notifications";

interface Props {
    workOrderIds: string[];
    filteredData: IWorkOrder[];
}

/** A API aceita várias OSs por relatório; o front libera uma por vez até a regra ser revista. */
const MAX_WORK_ORDERS_PER_REPORT = 1;

export const DownloadWorkOrderReport = ({ workOrderIds, filteredData }: Props) => {

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    /** Retorna a mensagem do impedimento ou `null` quando a seleção é exportável. */
    const validateSelection = (): string | null => {
        if (!workOrderIds || workOrderIds.length === 0) {
            return MESSAGES.WORK_ORDER_REPORT.EMPTY_SELECTION;
        }

        if (workOrderIds.length > MAX_WORK_ORDERS_PER_REPORT) {
            return MESSAGES.WORK_ORDER_REPORT.SINGLE_SELECTION_ONLY;
        }

        const selectedItems = filteredData.filter(item =>
            item.id && workOrderIds.includes(item.id as string)
        );

        if (selectedItems.length === 0) {
            return MESSAGES.WORK_ORDER_REPORT.EMPTY_SELECTION;
        }

        const [firstItem] = selectedItems;

        if (selectedItems.some(item => item.createdBy !== firstItem.createdBy)) {
            return MESSAGES.WORK_ORDER_REPORT.DIFFERENT_CREATOR;
        }

        if (selectedItems.some(item => item.serviceType !== firstItem.serviceType)) {
            return MESSAGES.WORK_ORDER_REPORT.DIFFERENT_SERVICE_TYPE;
        }

        return null;
    };

    const handleExportClick = async () => {
        if (isSubmitting) {
            return;
        }

        const validationError = validateSelection();

        if (validationError) {
            showWarning(validationError);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await workOrderReportService.requestWorkOrderReport(workOrderIds);

            if (!response.success) {
                showWarning(response.error || MESSAGES.WORK_ORDER_REPORT.REQUEST_ERROR);
                return;
            }

            showSuccess(MESSAGES.WORK_ORDER_REPORT.REQUESTED);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Button
            color="light"
            icon="Upload"
            onClick={handleExportClick}
            isDisable={isSubmitting}
            aria-busy={isSubmitting}>
            {isSubmitting && <Spinner isSmall inButton isGrow />}
            {isSubmitting ? 'Solicitando...' : 'Exportar'}
        </Button>
    );
};
